import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPartnerAccountInventoryCheckBillingPolicyMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  new_inventory_checks_are_non_billable: Types.Scalars['Boolean'];
}>;


export type SetPartnerAccountInventoryCheckBillingPolicyMutation = { __typename?: 'Mutation', setPartnerAccountInventoryCheckBillingPolicy: { __typename?: 'EventAccount', id: string, new_inventory_checks_are_non_billable: boolean } };


export const SetPartnerAccountInventoryCheckBillingPolicyDocument = gql`
    mutation SetPartnerAccountInventoryCheckBillingPolicy($event_account_id: ID!, $new_inventory_checks_are_non_billable: Boolean!) {
  setPartnerAccountInventoryCheckBillingPolicy(
    event_account_id: $event_account_id
    new_inventory_checks_are_non_billable: $new_inventory_checks_are_non_billable
  ) {
    id
    new_inventory_checks_are_non_billable
  }
}
    `;
export type SetPartnerAccountInventoryCheckBillingPolicyMutationFn = Apollo.MutationFunction<SetPartnerAccountInventoryCheckBillingPolicyMutation, SetPartnerAccountInventoryCheckBillingPolicyMutationVariables>;

/**
 * __useSetPartnerAccountInventoryCheckBillingPolicyMutation__
 *
 * To run a mutation, you first call `useSetPartnerAccountInventoryCheckBillingPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPartnerAccountInventoryCheckBillingPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPartnerAccountInventoryCheckBillingPolicyMutation, { data, loading, error }] = useSetPartnerAccountInventoryCheckBillingPolicyMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      new_inventory_checks_are_non_billable: // value for 'new_inventory_checks_are_non_billable'
 *   },
 * });
 */
export function useSetPartnerAccountInventoryCheckBillingPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SetPartnerAccountInventoryCheckBillingPolicyMutation, SetPartnerAccountInventoryCheckBillingPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPartnerAccountInventoryCheckBillingPolicyMutation, SetPartnerAccountInventoryCheckBillingPolicyMutationVariables>(SetPartnerAccountInventoryCheckBillingPolicyDocument, options);
      }
export type SetPartnerAccountInventoryCheckBillingPolicyMutationHookResult = ReturnType<typeof useSetPartnerAccountInventoryCheckBillingPolicyMutation>;
export type SetPartnerAccountInventoryCheckBillingPolicyMutationResult = Apollo.MutationResult<SetPartnerAccountInventoryCheckBillingPolicyMutation>;
export type SetPartnerAccountInventoryCheckBillingPolicyMutationOptions = Apollo.BaseMutationOptions<SetPartnerAccountInventoryCheckBillingPolicyMutation, SetPartnerAccountInventoryCheckBillingPolicyMutationVariables>;